import { render, staticRenderFns } from "./drawerRight.vue?vue&type=template&id=a10cb8fc&scoped=true&"
import script from "./drawerRight.vue?vue&type=script&lang=js&"
export * from "./drawerRight.vue?vue&type=script&lang=js&"
import style0 from "./drawerRight.vue?vue&type=style&index=0&id=a10cb8fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10cb8fc",
  null
  
)

component.options.__file = "drawerRight.vue"
export default component.exports